export default (value?: boolean) => value ?? null;
